import API from '../api';

// function to get single place data
export const getAllPlaceData = async (slug: string) => {
  let response = await API.get(`/places/admin/${slug}`);
  return response.data;
}